export default "__VITE_ASSET__Dalcw1RB__"